/**
 * This contains recurring values/constants used by API logic
 *
 * NOTE: If there are newly added values (constants or environment variables) that
 * are recurring across the API logic, they should be ideally added here
 */
const API_PATH = import.meta.env.VITE_API_PATH ?? '';
const VITE_HTTPS_PROTOCOL = import.meta.env.VITE_HTTPS_PROTOCOL ?? '';

export const CUSTOMER_AUTH_LOGIN = {
  USER_PASS: `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant/login`,
  USER_OTP: `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant/login/code`,
};

export const ROLE_VALUES = {
  WHISTLE_BLOWER: 1,
  TENANT_USER: 2,
  TENANT_ADMIN: 3,
  EXTERNAL_USER: 5,
  PARTNER_USER: 6,
  PARTNER_ADMIN: 7,
};

export interface AdminPiiRemovalRequestBody {
  full_name?: null;
  country?: null;
  files?: null;
  description_pii_removed_ranges?: [number, number][];
  pii_removed_messages?: { id: string; content_pii_removed_ranges: [number, number][] }[];
}

export interface TenantPiiRemovalRequestBody {
  report_reference?: string;
  messages?: { id: string; content_pii_removed_ranges: [number, number][] }[];
  remove_full_name?: boolean;
  remove_country?: boolean;
  remove_files?: boolean;
  description_pii_removed_ranges?: [number, number][];
}

export const CUSTOMER_GOOGLE_LOGIN = `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant/login/google/redirect`;

export const CUSTOMER_AUTH_REGISTER = `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant/register`;

export const CUSTOMER_INFO = `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant`;

export const CUSTOMER_REPORTS_LIST = (slug: string): string => {
  return `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant/${slug}/report-list`;
};

export const CUSTOMER_REPORT = (
  slug: string | null,
  report_id: string,
): string => {
  return `${VITE_HTTPS_PROTOCOL}${API_PATH}/tenant/${slug}/report-list/${report_id}`;
};

export const SWR_KEY_URLS = {
  policyCommentsList: 'program-policy/comments',
};
